import { useState, useEffect } from 'react';
const useManufacturer = data => {
  const [manufacturer, setManufacturer] = useState(data?.car?.manufacturer || '');
  useEffect(() => {
    if (data?.car?.manufacturer) {
      setManufacturer(data.car.manufacturer);
    }
  }, [data]);
  return manufacturer;
};
export default useManufacturer;